import { Image } from '@gyym/ui'
import React from 'react'

import step1Img from '@/../public/assets/images/top/usage_step_1.svg'
import step2Img from '@/../public/assets/images/top/usage_step_2.svg'
import step3Img from '@/../public/assets/images/top/usage_step_3.svg'

import {
  Container,
  Content,
  Covid,
  Heading,
  ImageWrapper,
  Item,
  List,
  Precaution,
} from './styles'

export const UsageSteps = () => {
  return (
    <Container>
      <List>
        <Item>
          <div>
            <Heading>無料で会員登録</Heading>
            <Content>
              会員登録に必要な情報を入力し、会員登録を完了させます。
            </Content>
          </div>
          <ImageWrapper>
            <Image src={step1Img} alt="無料で会員登録" height={80} width={80} />
          </ImageWrapper>
        </Item>

        <Item>
          <div>
            <Heading>プログラム検索・予約</Heading>
            <Content>
              施設やプログラムを検索。ポイントを購入し、予約を完了させます。
              <br />
              <Precaution>※1ポイント=1円</Precaution>
            </Content>
          </div>
          <ImageWrapper>
            <Image
              src={step2Img}
              alt="プログラム検索・予約"
              height={80}
              width={80}
            />
          </ImageWrapper>
        </Item>

        <Item>
          <div>
            <Heading>プログラム受講</Heading>
            <Content>予約名を伝えて、予約画面を見せるだけです。</Content>
          </div>
          <ImageWrapper>
            <Image src={step3Img} alt="プログラム受講" height={80} width={80} />
          </ImageWrapper>
        </Item>
      </List>

      <Covid>
        提携施設は感染症予防対策に取り組んでいます。各施設の取り組みは施設ページよりご確認頂けます。お客様におかれましても、感染症対策にご協力ください。
      </Covid>
    </Container>
  )
}
